var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIconSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.91597 14.166C9.34097 14.166 10.6551 13.6885 11.7076 12.8852L15.6601 16.8385C15.8173 16.9903 16.0278 17.0743 16.2463 17.0724C16.4648 17.0705 16.6738 16.9829 16.8283 16.8284C16.9828 16.6739 17.0705 16.4649 17.0724 16.2464C17.0743 16.0279 16.9903 15.8174 16.8385 15.6602L12.8851 11.7069C13.7404 10.5857 14.1914 9.20831 14.1649 7.79843C14.1384 6.38855 13.6359 5.02908 12.739 3.94092C11.8421 2.85276 10.6036 2.09987 9.22477 1.80459C7.84591 1.5093 6.40771 1.68899 5.14388 2.31444C3.88005 2.93989 2.86487 3.97435 2.26329 5.24972C1.66172 6.52509 1.50912 7.96641 1.83028 9.33948C2.15144 10.7125 2.92749 11.9367 4.03232 12.8129C5.13716 13.6891 6.50584 14.166 7.91597 14.166ZM12.4993 7.91602C12.4993 9.1316 12.0164 10.2974 11.1569 11.1569C10.2973 12.0165 9.13154 12.4994 7.91597 12.4994C6.70039 12.4994 5.5346 12.0165 4.67506 11.1569C3.81552 10.2974 3.33263 9.1316 3.33263 7.91602C3.33263 6.70045 3.81552 5.53466 4.67506 4.67512C5.5346 3.81558 6.70039 3.33269 7.91597 3.33269C9.13154 3.33269 10.2973 3.81558 11.1569 4.67512C12.0164 5.53466 12.4993 6.70045 12.4993 7.91602Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconSvg);
export default __webpack_public_path__ + "static/media/search-icon-svg.26653aa3050cefc455eaf12073ee1a87.svg";
export { ForwardRef as ReactComponent };